import {Eye} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import {Label} from "@/components/ui/label.tsx";
import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover.tsx";
import {Slider} from "@/components/ui/slider.tsx";
import {Switch} from "@/components/ui/switch.tsx";
import {useGameMasterViewSettings} from "@/tabletop/gm/GameMasterViewSettingsHooks.ts";

export default function VisibilityControls() {
    const {showPlayerSight, setShowPlayerSight, showHostileSight, setShowHostileSight,
        gmMaskOpacity, setGmMaskOpacity} = useGameMasterViewSettings();

    return <Popover>
        <PopoverTrigger asChild>
            <Button type="button" variant="ghost" size="icon" title="Sicht-Einstellungen"
                className="data-[state=open]:bg-secondary"
                aria-label="Sicht-Einstellungen">
                <Eye/>
            </Button>
        </PopoverTrigger>
        <PopoverContent side="top" align="center"
            className="max-h-[min(70vh,560px)] w-72 space-y-4 overflow-y-auto">
            <h3 className="text-sm font-semibold">Sicht-Einstellungen</h3>
            <div className="flex items-center justify-between gap-3">
                <div className="space-y-1">
                    <Label htmlFor="show-player-sight">Spielersicht</Label>
                    <p className="text-xs text-muted-foreground">Maske in der Spielleiteransicht anzeigen</p>
                </div>
                <Switch id="show-player-sight" checked={showPlayerSight}
                        onCheckedChange={setShowPlayerSight}/>
            </div>
            <div className="flex items-center justify-between gap-3">
                <div className="space-y-1">
                    <Label htmlFor="show-hostile-sight">Feindsicht</Label>
                    <p className="text-xs text-muted-foreground">Rote Sichtpolygone anzeigen</p>
                </div>
                <Switch id="show-hostile-sight" checked={showHostileSight}
                        onCheckedChange={setShowHostileSight}/>
            </div>
            <div className="space-y-3 border-t pt-4">
                <div className="flex items-center justify-between">
                    <Label htmlFor="gm-mask-opacity">GM-Maskendeckkraft</Label>
                    <span className="text-sm tabular-nums">{Math.round(gmMaskOpacity * 100)} %</span>
                </div>
                <Slider id="gm-mask-opacity" min={0} max={100} step={5}
                        value={[Math.round(gmMaskOpacity * 100)]}
                        onValueChange={values => setGmMaskOpacity(values[0] / 100)}/>
                <p className="text-xs text-muted-foreground">Nur die Spielleiteransicht wird verändert.</p>
            </div>
        </PopoverContent>
    </Popover>;
}
